__turbopack_context__.v({
  "fadeIn": "faqSection-module__Zhrn8G__fadeIn",
  "faqAnswer": "faqSection-module__Zhrn8G__faqAnswer",
  "faqContainer": "faqSection-module__Zhrn8G__faqContainer",
  "faqDescription": "faqSection-module__Zhrn8G__faqDescription",
  "faqHeader": "faqSection-module__Zhrn8G__faqHeader",
  "faqIcon": "faqSection-module__Zhrn8G__faqIcon",
  "faqItem": "faqSection-module__Zhrn8G__faqItem",
  "faqItemButton": "faqSection-module__Zhrn8G__faqItemButton",
  "faqItemContent": "faqSection-module__Zhrn8G__faqItemContent",
  "faqItemOpen": "faqSection-module__Zhrn8G__faqItemOpen",
  "faqList": "faqSection-module__Zhrn8G__faqList",
  "faqListGrid": "faqSection-module__Zhrn8G__faqListGrid",
  "faqListList": "faqSection-module__Zhrn8G__faqListList",
  "faqQuestion": "faqSection-module__Zhrn8G__faqQuestion",
  "faqSection": "faqSection-module__Zhrn8G__faqSection",
  "faqSubtitle": "faqSection-module__Zhrn8G__faqSubtitle",
  "faqTitle": "faqSection-module__Zhrn8G__faqTitle",
});
